export const TOOLTIP_VARIANT = {
  SMALL: 's',
  LARGE: 'l',
} as const;

export const TOOLTIP_MODE = {
  LIGHT: 'light',
  DARK: 'dark',
  WHITE: 'white',
} as const;
